import { AnalysisStudioTab } from 'interfaces/study';
import { QueryParamConfig, StringParam, useQueryParam, withDefault } from 'use-query-params';

export const DatasetTab = 'Dataset';
export const WorkflowTab = 'Workflow';
export const AnnotationAssignmentsTab = 'Annotation Assignments';
export const JobsTab = 'Jobs';
export const CellRulesTab = 'Cell Rules';
export const QCMarkersTab = 'Markers QC';
export const QaAnalysisTab = AnalysisStudioTab.QaAnalysis;
export const MifMarkerUnsupervisedAnalysisTab = AnalysisStudioTab.MifMarkerUnsupervisedAnalysis;
export const CellNeighborhoodsTab = AnalysisStudioTab.CellNeighborhoods;
export const StudyReportTab = AnalysisStudioTab.StudyReport;

export type StudyDashboardTabOptions =
  | typeof DatasetTab
  | typeof WorkflowTab
  | typeof AnnotationAssignmentsTab
  | typeof JobsTab
  | typeof CellRulesTab
  | typeof QCMarkersTab
  | typeof QaAnalysisTab
  | typeof MifMarkerUnsupervisedAnalysisTab
  | typeof CellNeighborhoodsTab
  | typeof StudyReportTab;

export const StudyDashboardTabParam: QueryParamConfig<StudyDashboardTabOptions> = withDefault(
  StringParam,
  DatasetTab
) as QueryParamConfig<StudyDashboardTabOptions>;

export const useStudyDashboardTabState = () => {
  return useQueryParam<StudyDashboardTabOptions>('studyDashboardTab', StudyDashboardTabParam, {
    updateType: 'replaceIn',
  });
};
